import { render, staticRenderFns } from "./UserManagementTransactionSummaryTab.vue?vue&type=template&id=ebc05418&scoped=true&lang=pug"
import script from "./UserManagementTransactionSummaryTab.vue?vue&type=script&lang=ts"
export * from "./UserManagementTransactionSummaryTab.vue?vue&type=script&lang=ts"
import style0 from "./UserManagementTransactionSummaryTab.vue?vue&type=style&index=0&id=ebc05418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc05418",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VDataTable,VIcon,VRow,VSpacer})
